import axios from 'axios';
import { toast } from 'react-toastify';
import { decodeToken } from '../utils/jwtUtils';
import { socket } from '../config/Socket';
import config from '../config';

export const apiInstance = axios.create({
  baseURL: config.BASE_URL
});

apiInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem('callex-token'));
    config.headers.Authorization = token ? `Bearer ${token}` : undefined;
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor
apiInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.log('error', error);
    if (
      typeof error.response.data.message === 'string' ||
      typeof error.response.data.error === 'string'
    ) {
      if (error.response.data.message === 'Token expired.' && error.response.status === 401) {
        const token = JSON.parse(localStorage.getItem('callex-token'));
        const user = decodeToken(token);
        if (user?.type === 'User') {
          socket.emit('user_logout', {
            user_id: user?.user_id,
            process_id: user?.process_details?.process_id,
            company_id: user?.companyId,
            type: user?.type
          });
        }
        localStorage.clear();
        // socket.disconnect();
        localStorage.removeItem('timerDuration');
        localStorage.removeItem('timerStartTime');
        window.location.reload();
      } else if (error.response.data.message === 'Internal Server Error') {
        toast.error(error.response.data.error);
      } else {
        toast.error(error.response.data.message || error.response.data.error);
      }
    } else {
      for (let i = 0; i < error?.response?.data?.message?.length; i++) {
        toast.error(error.response.data.message[i]);
      }
    }
    return Promise.reject(error);
  }
);
